import {
	SparkPackage,
	SparkPackageMark,
	SparkPackageName,
	SparkPackages,
} from '../BuyTokensModal.styles';
import { PACKAGE_KEYS, PACKAGE_MARKS } from '../constants/buyTokensModal.constants';

const BuyTokensPackageList = ({
	selectedKey,
	onSelect,
	packagePrices,
	packagesLabel,
	packageTranslations,
}) => (
	<SparkPackages role="radiogroup" aria-label={packagesLabel}>
		{PACKAGE_KEYS.map((key) => {
			const pkg = packageTranslations?.[key];
			const selected = selectedKey === key;

			return (
				<SparkPackage
					key={key}
					type="button"
					role="radio"
					$selected={selected}
					aria-checked={selected}
					onClick={() => onSelect(key)}
				>
					<SparkPackageMark>{PACKAGE_MARKS[key]}</SparkPackageMark>
					<SparkPackageName>
						{pkg?.name} <small>{pkg?.sparks}</small>
					</SparkPackageName>
					<strong>{packagePrices[key]}</strong>
				</SparkPackage>
			);
		})}
	</SparkPackages>
);

export default BuyTokensPackageList;
